export default function (logos) {
  let rowCount = 1;
  logos.forEach((data) => {
    if (data.logo.row + 1 > rowCount) rowCount = data.logo.row + 1;
  });

  let logoItems = Array.apply(null, Array(rowCount));

  logos.forEach(({ logo }) => {
    if (logoItems[logo.row]) logoItems[logo.row].push(logo);
    else logoItems[logo.row] = [logo];
  });

  return { rowCount, logoItems };
}
